export default {
  Summary: 0,
  All: 1,
  Shared: 2,
  BusinessAndService: 3,
  AdministrativeCareer: 4,
};
